import React from 'react';
import { useSelector } from 'react-redux';
import GetCreditReport from './GetCreditReport';
import SimilarOffers from './SimilarOffers';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import styles from '../styles/lead/Lead.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEnvelope, faPhoneAlt, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';

const LeadThankYou = (props) => {
    const {leadId, subscribe, userEmail, leadStatus, leadProvider} = props;
    const user = useSelector(state => state.user);

    const newsletterMsg = subscribe &&
        <Row className={`p-3 mt-3 no-gutters ${styles.infoBox}`}>
            <Col>      
                <p className={`${styles.section} mb-0 text-uppercase`}>
                    <FontAwesomeIcon icon={faEnvelope} width="16" height="16" className="mr-2" />
                    Abonare Newsletter
                </p>
                <p className={`mb-1 mb-md-0 ${styles.title} `}>
                   {subscribe.status}
                </p>
                <p className={`${styles.description} mb-2`}>{subscribe.message}</p>   
            </Col>
        </Row>;

    const successMsg = 
        <Row className={`p-3 no-gutters ${styles.infoBox}`}>
            <Col>      
                <p className={`${styles.section} mb-2 text-uppercase`}>    
                    Status aplicație
                </p>
                {(leadStatus == 'NEW' || leadStatus == 'SENT') &&
                <p className={`mb-2 ${styles.description}`}>
                    <FontAwesomeIcon icon={faPhoneAlt} width="16" height="16" className="mr-2" />
                    Urmează să fii contactat telefonic în scurt timp de către un consultant financiar {leadProvider}.  
                </p> 
                }
                
                {(leadStatus == 'DUPLICATE') &&
                <p className={`mb-2 ${styles.description}`}>
                    <FontAwesomeIcon icon={faExclamationCircle} width="16" height="16" className="mr-2 red" />
                    Aplicație duplicat: Există deja o cerere similară înregistrată în ultimele 7 zile
                </p> 
                }

                {(leadStatus == 'INVALID') &&
                <p className={`mb-2 ${styles.description}`}>
                    <FontAwesomeIcon icon={faExclamationCircle} width="16" height="16" className="mr-2 red" />
                    Aplicație invalidă: Cererea nu îndeplinește cerintele necesare.
                </p> 
                }
            </Col>
        </Row>;

    return (
        <>
            {successMsg}
            {newsletterMsg}
            {(user.isLoggedIn && (leadStatus == 'NEW' || leadStatus == 'SENT') ) && <GetCreditReport /> }
            <SimilarOffers leadId={leadId} />
        </>
    );
}

export default LeadThankYou;